import React from 'react';

export function LoadingSpinner({ size = 32, inline = false }: { size?: number; inline?: boolean }) {
  return (
    <div style={{
      display: inline ? 'inline-flex' : 'flex',
      alignItems: 'center', justifyContent: 'center',
      padding: inline ? 0 : '40px 0',
      gap: 10,
    }}>
      <style>{`@keyframes ldSpin { to { transform: rotate(360deg); } }`}</style>
      <div style={{
        width: size, height: size,
        border: `3px solid var(--ld-primary-light)`,
        borderTopColor: 'var(--ld-primary)',
        borderRadius: '50%',
        animation: 'ldSpin 0.7s linear infinite',
        flexShrink: 0,
      }} />
    </div>
  );
}

export function LoadingBlock({ text = 'Wird geladen …' }: { text?: string }) {
  return (
    <div style={{ padding: '48px 24px', textAlign: 'center' }}>
      <LoadingSpinner />
      <div style={{ marginTop: 12, fontSize: 13, color: 'var(--ld-text-secondary)', fontWeight: 500 }}>{text}</div>
    </div>
  );
}

export function EmptyState({
  icon, title, subtitle, action,
}: {
  icon: string;
  title: string;
  subtitle?: string;
  action?: { label: string; onClick: () => void };
}) {
  return (
    <div style={{ padding: '48px 24px', textAlign: 'center' }}>
      <div className="ld-empty-state-icon" style={{ fontSize: 48, marginBottom: 14, lineHeight: 1 }}>{icon}</div>
      <div style={{ fontSize: 16, fontWeight: 700, color: 'var(--ld-text-primary)', marginBottom: 6 }}>{title}</div>
      {subtitle && (
        <div style={{ fontSize: 13, color: 'var(--ld-text-secondary)', lineHeight: 1.6, maxWidth: 280, margin: '0 auto' }}>{subtitle}</div>
      )}
      {action && (
        <button
          onClick={action.onClick}
          style={{
            marginTop: 20, padding: '10px 22px',
            background: 'var(--ld-primary)', color: 'white',
            border: 'none', borderRadius: 'var(--ld-radius-md)', fontSize: 14, fontWeight: 600,
            cursor: 'pointer', boxShadow: '0 4px 14px rgba(107, 95, 212,0.35)',
            minHeight: 44,
          }}
        >
          {action.label}
        </button>
      )}
    </div>
  );
}
